import { FunctionComponent, PropsWithChildren, SVGProps } from "react";
import { Stack, Typography } from "@mui/material";
import MainLayoutErrorIcon from "assets/images/no-data.svg?react";
import styles from "./GenericFallback.styles";

type TFallbackProps = PropsWithChildren<{
  message?: string;
  icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
}>;

const GenericFallback = ({
  children,
  message,
  icon: Icon = MainLayoutErrorIcon,
}: TFallbackProps) => (
  <Stack sx={styles.errorContainer}>
    <Icon />
    <Typography variant="h6" component="h1" data-qaid="error-message">
      {message || ""}
    </Typography>
    {children}
  </Stack>
);

export default GenericFallback;
